import React, { useState } from "react";
import { useContext } from 'react';
import DataContext from '../context/DataContext';
import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import reactImage from "../assets/react.png";
import python from "../assets/python.png";
import firebase from "../assets/firebase.png";
import github from "../assets/github.png";
import tailwind from "../assets/tailwind.png";
import bootstrap from "../assets/bootstrap.png";

const Experience = () => {
  const  {
    isDarkMode ,
    setIsDarkMode ,
    textColor ,
    bgColor } =  useContext(DataContext) ;
  
  const techs = [
    {
      id: 1,
      src: html,
      title: "HTML",
      style: "shadow-orange-500" ,
    },
    {
      id: 2,
      src: css,
      title: "CSS",
      style:  "shadow-blue-500" ,
    },
    {
      id: 3,
      src: javascript,
      title: "JavaScript",
      style:  "shadow-yellow-500",
    },
    {
      id: 4,
      src: reactImage,
      title: "React",
      style:  "shadow-blue-600" ,
    },
    {
      id: 5,
      src: tailwind,
      title: "Tailwind",
      style:  "shadow-sky-400",
    },
    {
      id: 6,
      src: python,
      title: "Python ",
      style:  "shadow-blue-400" ,
    },
    {
      id: 7,
      src: firebase,
      title: "Firebase",
      style:  "shadow-orange-400" ,
    },
    {
      id: 8,
      src: github,
      title: "GitHub",
      style:  "shadow-gray-400" ,
    },
    {
      id: 9,
      src: bootstrap,
      title: "Bootstrap",
      style:  "shadow-purple-400" ,
    },
  ];

  const toggleMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div
      name="experience"
      className={`  p-4 ${bgColor} ${textColor}`}
    >
      <div className=" p-4 max-w-screen-lg mx-auto flex flex-col justify-center w-full h-full text-white">
        <div>
          <p className= {`text-4xl font-bold border-b-4 p-2 mt-5  inline  ${textColor}`} >
            Experience
          </p>
          <p className={`my-6 p-4 ${textColor}`} >Here are the technologies I'm comfortable with </p>
        </div>


        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {techs.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style} ${bgColor} ${textColor}`}
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
